import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import dayjs from "dayjs";
import FeedbackTable from "../components/FeedbackTable";
import HomeIcon from "@mui/icons-material/Home";
import InventoryInput from "../components/InventoryInput";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SendIcon from "@mui/icons-material/Send";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  Feedback,
  Items,
  ItemsData,
  QuantityData,
  getItems,
  updateQuantities,
} from "../lib/api";

export default function Inventory() {
  const { table } = useParams<string>();
  const autherRef = useRef<HTMLInputElement>(null);

  const [items, setItems] = useState<Items>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [feedback, setFeedback] = useState<Feedback | null>(null);

  let data: ItemsData[] = [];

  const setQuantity = (name: string, quantities: QuantityData[]) => {
    let item = data.find((item) => item.name === name);
    if (!item) {
      data.push({ name, quantities });
    } else {
      item.quantities = quantities;
    }
  };

  const handleSubmit = () => {
    const date = dayjs().format("MM/DD/YYYY");
    const author = autherRef.current?.value;
    if (!table) {
      window.alert("No table selected");
      return;
    }
    if (!author) {
      window.alert("Please enter your name");
      return;
    }
    if (!items) {
      window.alert("No items to submit");
      return;
    }
    setIsSubmitting(true);
    updateQuantities(table, date, author, data)
      .then((response) => {
        setFeedback(response.data);
      })
      .catch((err) => {
        console.error(err);
        window.alert(`Failed to submit items: ${err}`);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    getItems(table ?? "unknown")
      .then((response) => setItems(response.data))
      .catch((err) => {
        console.error(err);
        window.alert(`Failed to load items from table ${table}: ${err}`);
      });
  }, [table]);

  if (!items || isSubmitting) {
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (feedback === null) {
    return (
      <Container sx={{ mt: 4 }}>
        <Stack spacing={2}>
          <Stack spacing={1}>
            <Typography variant="h5">Input your name</Typography>
            <TextField inputRef={autherRef} label="Name" variant="outlined" />
          </Stack>
          <Stack spacing={1}>
            <Typography variant="h5">Input current inventory</Typography>
            <InventoryInput items={items} setQuantity={setQuantity} />
          </Stack>
          <Stack spacing={2} direction="row" justifyContent="space-between">
            <Button
              variant="contained"
              color="error"
              href="../"
              startIcon={<ArrowBackIcon />}
            >
              Back
            </Button>
            <Button
              variant="contained"
              onClick={() => handleSubmit()}
              endIcon={<SendIcon />}
            >
              Submit
            </Button>
          </Stack>
        </Stack>
      </Container>
    );
  }

  return (
    <div>
      <Stack spacing={2} direction="row">
        <Button variant="outlined" href="../" endIcon={<HomeIcon />}>
          Back
        </Button>
        <Button
          variant="outlined"
          onClick={() => setFeedback(null)}
          endIcon={<RestartAltIcon />}
        >
          Reset
        </Button>
      </Stack>
      <FeedbackTable feedback={feedback} />
    </div>
  );
}
